<!--  -->
<template>
  <div class="content">
    <div class="ban" @click="topUrl(3, '/Contact_us')">
      <img src="http://www.hitaledu.com/img/serve.png" alt="湖南生易圈教育咨询有限公司" />
    </div>
    <!-- 平台介绍 -->
    <div class="Platform_introduction">
      <div class="card">
        <div class="left">
          <div class="Freight">Freight teaching platform</div>
          <div class="title">平台介绍</div>
          <img class="img" src="../../assets/servie/line.png" alt="湖南生易圈教育咨询有限公司" />
          <div class="info">
            <div>
                                 基于二十多年货运实操系统的基础上，结合专业建设人才培养方案和业务实际案例开发的适用于国际货运代理课程实践教学的实训平台。老师利用线下教学+线上实操演示的教学模式，让学生在平台模拟货物运输操作。
            </div>
            <div>
              学生根据老师选定的业务案例背景，在平台模拟货运实操，系统会自动比对答案，按步提示是否正确，并显示错误点，同时统计业务实操积分及分数。
            </div>

            平台通过成绩管理统计查询业务案例实操结果、总分、扣分和得分等成绩结果；查询错题和案例成绩分析结果。
          </div>
          <!-- <div class="bott" @click="topUrl(3, '/Contact_us')">免费试用</div> -->
        </div>
        <div class="left">
          <img src="../../assets/servie/img.png" alt="湖南生易圈教育咨询有限公司" />
        </div>
      </div>
    </div>

    <!-- 平台模板 -->
    <div class="Platform_template">
      <Link text="平台模块" />
      <div class="card">
        <div class="list">
          <div
            class="li"
            v-for="(item, index) in card_list"
            :key="index"
            v-show="index < 5"
          >
            <img :src="item.img" alt="湖南生易圈教育咨询有限公司" />
            <div class="text">{{ item.text }}</div>
          </div>
        </div>
        <div class="list">
          <div
            class="li"
            v-for="(item, index) in card_list"
            :key="index"
            v-show="index > 4"
          >
            <img :src="item.img" alt="湖南生易圈教育咨询有限公司" />
            <div class="text">{{ item.text }}</div>
          </div>
        </div>
      </div>
    </div>
    <!-- 六大功能 -->
    <div class="Six_functions">
      <Link text="六大功能" />
      <div class="card">
        <div class="list">
          <div
            class="li"
            :style="
              'background: ' +
              item.background +
              ' no-repeat; background-size: 100% 100%;'
            "
            v-for="(item, index) in six_list"
            :key="index"
          >
            <div class="title">{{ item.title }}</div>
            <div class="text">{{ item.text }}</div>
          </div>
        </div>
      </div>
    </div>
    <!-- 产品价格 -->
    <div class="price">
      <Link text="产品价格" />
      <div class="card">
        <div class="list">
          <div class="li" v-for="(item, index) in price_list" :key="index">
            <img :src="item.img" alt="湖南生易圈教育咨询有限公司" />
            <div class="title">{{item.title}}</div>
            <div class="text">
               {{item.text}}
            </div>
            <div class="pric_text">{{item.pric}} <span>{{item.danwei}}</span></div>
          </div>
        </div>
      </div>
    </div>
       <!-- 我们的过往案例 -->
    <div class="case card">
      <Link text="我们的案例" />
      <div
        trigger="click"
        class="lbt"
        height="420px"
        indicator-position="outside"
      >
        <div class="list">
          <div class="li">
            <img src="../../assets/servie/img1.jpg" alt="湖南生易圈教育咨询有限公司" />
            <div class="info">
              <div class="title">衡阳技师学院</div>
              <div class="text">2019年</div>
              <div class="text width">
              根据衡阳技师学院教师理论与实际相结合的教学需要，我司信息技术团队、
              教研团队与学校经过多次讨论和修改，完成货运教学系统的开发和设计。已完成平台使用教学及交付。

              </div>
            </div>
          </div>
           <div class="li">
            <img src="../../assets/servie/ing2.jpg" alt="湖南生易圈教育咨询有限公司" />
            <div class="info">
              <div class="title">中南林业科技大学国际学院</div>
              <div class="text">2020年</div>
              <div class="text width">
               2017级国际经济与贸易专业1-6班，2017级物流管理专业1班，
                2018、2019级国际经济与贸易专业留学生班，学生使用平台上机实操模拟的成绩计入毕业实习考核。

              </div>
            </div>
          </div>
          
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Link from "../../components/all_text.vue";
export default {
  //import引入的组件需要注入到对象中才能使用
  components: {
    Link,
  },
  data() {
    //这里存放数据
    return {
      six_list: [
        {
          title: "线上实操",
          text: "数字化操作实现数据精准有效填写。",
          background: "url(" + require("../../assets/servie/1.png") + ")",
        },
        {
          title: "智能对比",
          text: "学生在实操录入后，系统会自动进行数据对比。",
          background: "url(" + require("../../assets/servie/2.png") + ")",
        },
        {
          title: "智能评分",
          text: "全流程记录学生实际录入操作，进行积分制，系统自动评分。",
          background: "url(" + require("../../assets/servie/3.png") + ")",
        },
        {
          title: "成绩管理",
          text: "快速查询学生实操结果，并统计所有实操信息。",
          background: "url(" + require("../../assets/servie/4.png") + ")",
        },
        {
          title: "案例管理",
          text: "老师可在丰富的案例库中挑选实操案例和上传实操案例信息。",
          background: "url(" + require("../../assets/servie/5.png") + ")",
        },
        {
          title: "竞赛题库",
          text: "学生可操作世界技能大赛货运代理项目比赛试题。",
          background: "url(" + require("../../assets/servie/6.png") + ")",
        },
      ],
      card_list: [
        {
          img: require("../../assets/servie/13.png"),
          text: "案例管理",
        },
        {
          img: require("../../assets/servie/ioc1.png"),
          text: "现场管理",
        },
        {
          img: require("../../assets/servie/ioc3.png"),
          text: "报价管理",
        },
        {
          img: require("../../assets/servie/ioc4.png"),
          text: "单证管理",
        },
        {
          img: require("../../assets/servie/ioc5.png"),
          text: "操作管理",
        },
        {
          img: require("../../assets/servie/14.png"),
          text: "统计查询",
        },
        {
          img: require("../../assets/servie/ioc12.png"),
          text: "档案管理",
        },
        {
          img: require("../../assets/servie/ioc8.png"),
          text: "成绩管理",
        },
        {
          img: require("../../assets/servie/ioc7.png"),
          text: "成绩分析",
        },
        {
          img: require("../../assets/servie/15.png"),
          text: "竞赛题库",
        },
      ],
      price_list:[
        {
          img:require("../../assets/servie/Icon1.png"),
          title:"实训课程整体解决方案",
          text:'将企业案例带入课堂实景教学，使用平台模拟真实操作，满足高校专业所需',
          pric:'8000-20000',
          danwei:'元/天'
        },
         {
          img:require("../../assets/servie/Icon2.png"),
          title:"竞赛租用",
          text:'结合比赛模块进行模拟训练，帮助选手熟练掌握操作技巧',
          pric:'49800',
          danwei:'元/学期'
        },
         {
          img:require("../../assets/servie/Icon3.png"),
          title:"平台采购",
          text:'根据客户需求进行定制化案例搭配,提供贴合需求的售后服务',
          pric:'168000',
          danwei:'元'
        },
         {
          img:require("../../assets/servie/Icon4.png"),
          title:"定制开发",
          text:'通过院校理论支持与企业实际案例相结合，共享资源，打造专属特色软件',
          pric:'商谈',
          danwei:''
        }
      ],
    };
  },
  //监听属性 类似于data概念
  computed: {},
  //监控data中的数据变化
  watch: {},
  //方法集合
  methods: {
    //跳转
    topUrl(index, url) {
      this.$router.push(url);
      this.$store.state.current = index;
      localStorage.setItem("current",3);
    },
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {},
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {},
  beforeCreate() {}, //生命周期 - 创建之前
  beforeMount() {}, //生命周期 - 挂载之前
  beforeUpdate() {}, //生命周期 - 更新之前
  updated() {}, //生命周期 - 更新之后
  beforeDestroy() {}, //生命周期 - 销毁之前
  destroyed() {}, //生命周期 - 销毁完成
  activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style scoped lang="less">
@import url(../service_education/pc);
@import url(../service_education/mod);
</style>